import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { LicenseAdminListPage } from './LicenseAdminListPage';

export function LicenseAdminPage({ isExpanded }) {
  return (
    <Routes>
      <Route
        path="/"
        exact
        element={<LicenseAdminListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

LicenseAdminPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
